import type { OrderStatus } from "@school-sales-ai/shared";

/**
 * How an order's status reads on screen.
 *
 * The labels are the shop's own words, not the enum: `confirmed` means "the
 * order is taken and somebody has to deliver it", which is the state staff act
 * on, so it carries the one accent colour on the page.
 *
 * `swatch` is the solid dot the board's column header and the filter use.
 */
export const ORDER_STATUS_META: Record<
  OrderStatus,
  { label: string; className: string; swatch: string }
> = {
  open: { label: "Carrito abierto", className: "bg-ink-050 text-ink-600", swatch: "bg-ink-300" },
  confirmed: { label: "Por entregar", className: "bg-lime/20 text-moss", swatch: "bg-lime" },
  delivered: { label: "Entregado", className: "bg-ink-050 text-ink-600", swatch: "bg-moss" },
  cancelled: { label: "Cancelado", className: "bg-red-50 text-red-700", swatch: "bg-red-500" },
  abandoned: { label: "Abandonado", className: "bg-ink-050 text-ink-500", swatch: "bg-ink-200" },
};
